import cart from '../helpers/cart-helper'
import device from '../helpers/device'
import refs from '../helpers/refs'
import ButtonHelper from '../helpers/button-helper'

class CProductBottomPin {
  constructor (el) {
    this.hero = el
    this.$refs = refs(this.hero)

    this.variantID = cart.getDefaultVariantID()
    // Handle is required to get info about product object
    this.productHandle = cart.getProductHandle()

    this.init()
  }

  init () {
    if (this.$refs.openOverlay) {
      this.$refs.openOverlay.addEventListener('click', () => {
        const overlay = document.getElementById('c-out-of-stock__overlay')
        overlay.classList.replace('hidden', 'flex')
      })
    }

    if (this.$refs.addToCartButton) {
      this.$refs.addToCartButton.addEventListener('click', (e) => {
        // Handle iOS Safari's buggy click event behavior
        e.preventDefault()
        e.stopPropagation()

        if (device.isDesktop()) {
          const event = new CustomEvent('masterbuilt:open-cart-menu')
          document.dispatchEvent(event)
        } else {
          const button = this.$refs.addToCartButton
          const innerElem =
            button.children.length > 0 ? button.children[0] : button
          const buttonHelper = new ButtonHelper(button, innerElem)

          buttonHelper.setPendingState()

          // Add main product + accessories to cart
          // false = Don't open slideOutCart
          cart.addProductsToCart(
            [
              {
                id: this.variantID,
                quantity: this.quantity
              },
              ...this.getSelectedAccIDs().map(id => ({
                id,
                quantity: 1
              }))
            ],
            false
          )
            .then(() => {
              buttonHelper.setDoneState()

              // 8/19/2024 - Sarah wants the slide out cart to open every time, every device
              // cannot remove entire conditional - behavior should be the same, but it isn't
              // window.location.href = '/cart'
            })
            .catch((e) => {
              console.error('Error adding product to cart', e)
            })
        }
      })
    }
  }

  getSelectedAccIDs () {
    const accessories = Array.from(
      document.querySelectorAll('[ref="toggleRecco"] > input:checked')
    )
    return accessories.map(acc => acc.parentNode.dataset.accessoryId)
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document
    .querySelectorAll('[data-c-product-bottom-pin]')
    .forEach(el => new CProductBottomPin(el))
})
